import React from 'react';
import { Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Breadcrumb from '../../../layouts/full/shared/breadcrumb/Breadcrumb';
import PageContainer from '../../../components/container/PageContainer';
import BlankCard from 'src/components/shared/BlankCard';
import RegisterCard from 'src/components/management/email-recipients/email-recipient-add/EmailRecipientRegisterForm';

const BCrumb = [
  {
    to: '/',
    title: 'Home',
  },
  {
    title: 'Email Recipient Management',
  },
];

const AddEmailRecipient = () => {
  return (
    <PageContainer title="Email Recipient Management" description="this is Email Recipient Management page">
      {/* breadcrumb */}
      <Breadcrumb title="Email Recipient Management" items={BCrumb} />
      <Grid container spacing={3}>
        <Grid size={{ lg: 12 }}>
          <Stack spacing={3}>
            <BlankCard>
              <RegisterCard />
            </BlankCard>
          </Stack>
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default AddEmailRecipient;
